import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Part } from '../../services/partsApi';

interface PartsState {
  parts: Part[];
  loading: boolean;
  error: string | null;
  selectedPart: Part | null;
  total: number;
  page: number;
  limit: number;
}

const initialState: PartsState = {
  parts: [],
  loading: false,
  error: null,
  selectedPart: null,
  total: 0,
  page: 1,
  limit: 10,
};

const partsSlice = createSlice({
  name: 'parts',
  initialState,
  reducers: {
    fetchPartsStart: (state, action: PayloadAction<{ page?: number; limit?: number; search?: string }>) => {
      state.loading = true;
      state.error = null;
      if (action.payload.page) state.page = action.payload.page;
      if (action.payload.limit) state.limit = action.payload.limit;
    },
    fetchPartsSuccess: (state, action: PayloadAction<{ data: Part[]; total: number; page: number; limit: number }>) => {
      console.log('Parts Reducer: fetchPartsSuccess called with payload:', action.payload);
      console.log('Parts Reducer: action.payload.data:', action.payload.data);
      console.log('Parts Reducer: action.payload.data length:', action.payload.data?.length);
      console.log('Parts Reducer: action.payload.data is array:', Array.isArray(action.payload.data));
      
      state.parts = action.payload.data;
      state.total = action.payload.total;
      state.page = action.payload.page;
      state.limit = action.payload.limit;
      state.loading = false;
      
      console.log('Parts Reducer: State updated - parts length:', state.parts.length);
      console.log('Parts Reducer: State updated - total:', state.total);
      console.log('Parts Reducer: State updated - page:', state.page);
      console.log('Parts Reducer: State updated - limit:', state.limit);
    },
    fetchPartsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    addPart: (state, action: PayloadAction<Omit<Part, 'id'>>) => {
      // This will be handled by the saga
    },
    updatePart: (state, action: PayloadAction<Part>) => {
      // This will be handled by the saga
    },
    deletePart: (state, action: PayloadAction<string>) => {
      // This will be handled by the saga
    },
    setSelectedPart: (state, action: PayloadAction<Part | null>) => {
      state.selectedPart = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearParts: (state) => {
      state.parts = [];
      state.selectedPart = null;
      state.total = 0;
      state.page = 1;
    },
  },
});

export const {
  fetchPartsStart,
  fetchPartsSuccess,
  fetchPartsFailure,
  addPart,
  updatePart,
  deletePart,
  setSelectedPart,
  clearError,
  clearParts,
} = partsSlice.actions;

export default partsSlice.reducer; 